//#region imports

// react
import React, { useEffect, useLayoutEffect } from 'react';
import { NavBar } from '_molecules';
import { Container, Row, Col } from 'react-bootstrap';

//custom component
import { IphoneAndroid } from '_atoms';
import './styles.css';
import { useMediaQuery } from 'react-responsive'

//images
import iosimage from "_assets/images/PRM-Logo-PNG/ios-download.png";
import androidimage from "_assets/images/PRM-Logo-PNG/google-play.png";

//#endregion


function Download() {

    //#region media query and urls
    const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })
    const iOSUrl = 'https://apps.apple.com/ie/app/prm-assist/id1574371912';
    const androidUrl = 'https://play.google.com/store/apps/details?id=com.prmassist';
    //#endregion

    //#region useEffect
    useLayoutEffect(() => {
        if (isPhone) {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            // Android detection
            if (/android/i.test(userAgent)) {
                window.location.href = androidUrl;
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                window.location.href = iOSUrl;
            }
        }
    }, []);
    //#region render
    if (!isPhone) {
        // computer screen
        return (
            <>
                {/* Navbar */}
                <NavBar />

                {/* Main Container */}
                <Container fluid={true} className="mt-5 p-5">
                    {/* Info Row */}
                    <Container>
                        <Row xs={2}>
                            <Col className="mt-5">
                                <h1 className="fw-bold fs-1">Available on iOS and Android</h1>
                                <p className="fw-lighter fs-4 mt-5"> Download the PRM Assist mobile application for free.</p>
                                <p className="fw-lighter fs-4"> Create an account and start your journey.</p>
                                <p className="fw-lighter fs-4"> PRM Assist makes it simple.</p>

                                {/* download buttons */}
                                <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 50 }}>
                                    <div >
                                        <a href={iOSUrl}>
                                            <img src={iosimage} height={70} style={{ borderRadius: 10, borderWidth: 0.5 }} />
                                        </a>
                                    </div>
                                    <div >
                                        <a href={androidUrl}>
                                            <img src={androidimage} height={70} style={{ borderRadius: 10, borderWidth: 0.5 }} />
                                        </a>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <IphoneAndroid />
                            </Col>
                        </Row>
                    </Container>

                </Container>
            </>
        );
    }
    else {
        // mobile screen
        return (
            <>
                {/* Navbar */}
                <NavBar />

                {/* Main Container */}
                <Container className='mt-5 p-5'>
                    <h1 className="fw-bold fs-1">Available on iOS and Android.</h1>
                    <p className="fw-lighter fs-4 mt-3"> Download the PRM Assist mobile application for free.</p>

                    {/* Download Buttons */}
                    <div style={{ marginTop: 50, padding: 20, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around' }}>
                            <a href={iOSUrl}>
                                <img src={iosimage} height={50} style={{ borderRadius: 10, borderWidth: 0.5 }} />
                            </a>
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around' }}>
                            <a href={androidUrl}>
                                <img src={androidimage} height={50} style={{ borderRadius: 10, borderWidth: 0.5 }} />
                            </a>
                        </div>
                    </div>
                </Container>
            </>
        );
    }

};

export default Download;
